import React from "react";
import Image from "next/image";
import logo from "../../../../public/Images/header-logo.svg";
import styles from "./LoadingPage.module.css";

const LoadingPage = () => {
  return (
    <div className={styles.loadingContainer}>
      <div className={styles.loader}>
        <Image className="spinner-logo" src={logo} alt="Logo" width={180} height={90} />
        </div>
    </div>
  );
};

export default LoadingPage;
